$(document).ready(function () {
  const componentClassSelctor = '.component, [class^="c-"], [class^="js-c-"]'
  $(`input:checkbox:not(.no-uniform, ${componentClassSelctor})`).uniform()
  $(`input:radio:not(.no-uniform, ${componentClassSelctor})`).uniform()
})
